import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import stocks from '@/pages/stocks'
import restaurants from '@/pages/restaurants'
import restaurant from '@/pages/restaurant'
import restaurantReview from '@/pages/restaurantReview'
import product from '@/pages/product'
import cart from '@/pages/cart'
import article from '@/pages/article'
import about from '@/articles/about'
import blog from '@/pages/blog'
import singleBlog from '@/pages/singleBlog'
import forRestaurants from '@/pages/forRestaurants'
import contacts from '@/articles/contacts'
import presents from '@/pages/presents'
import partners from '@/pages/partners'
import work from '@/articles/work'
import wl from '@/articles/wl'
import franchise from '@/articles/franchise'
import clientIndex from '@/pages/lk/client/index'
import clientProfile from '@/pages/lk/client/profile'
import clientBonus from '@/pages/lk/client/bonus'
import clientReferral from '@/pages/lk/client/referral'
import userMonitor from '@/pages/lk/user/monitor'
import userPersonal from '@/pages/lk/user/personal'
import userReferral from '@/pages/lk/user/referral'
import userPresents from '@/pages/lk/user/presents'
import userPresent from '@/pages/lk/user/present'
import userRestaurants from '@/pages/lk/user/restaurants'
import userRestaurant from '@/pages/lk/user/restaurant'
import userStats from '@/pages/lk/user/stats'
import cabinet from '@/pages/lk/cabinet'
import oferta from '@/articles/oferta'
import sushi from '@/articles/sushi'
import pizza from '@/articles/pizza'
import snacks from '@/articles/snacks'
import healthy from '@/articles/healthy'
import burger from '@/articles/burger'
import dessert from '@/articles/dessert'
import cancer from '@/articles/cancer'
import lunch from '@/articles/lunch'
import pie from '@/articles/pie'
import barbecue from '@/articles/barbecue'
import salad from '@/articles/salad'
import cake from '@/articles/cake'
import beer from '@/articles/beer'
import development from '@/articles/development'
import seasonality from '@/articles/seasonality'
import profit from '@/articles/profit'
import secrets from '@/articles/secrets'
import soups from '@/articles/soups'
import targetolog from '@/articles/targetolog'
import coffee from '@/articles/coffee'
import investment from '@/articles/investment'
import saas from '@/articles/saas'
import authorsCuisine from '@/articles/authorsCuisine'
import asian from '@/articles/asian'
import unitedStates from '@/articles/unitedStates'
import armenian from '@/articles/armenian'
import balkan from '@/articles/balkan'
import eastern from '@/articles/eastern'
import european from '@/articles/european'
import georgian from '@/articles/georgian'
import indian from '@/articles/indian'
import italian from '@/articles/italian'
import caucasian from '@/articles/caucasian'
import chinese from '@/articles/chinese'
import korean from '@/articles/korean'
import mexican from '@/articles/mexican'
import russian from '@/articles/russian'
import slavic from '@/articles/slavic'
import japan from '@/articles/japan'
import exotic from '@/articles/exotic'
import kids from '@/articles/kids'
import diet from '@/articles/diet'
import cancers from '@/articles/cancers'
import cakes from '@/articles/cakes'
import osetinian from '@/articles/osetinian'
import inoffice from '@/articles/inoffice'
import gotovayaEda from '@/articles/gotovayaEda'
import voda from '@/articles/voda'
import faq from '@/articles/faq'
import business from '@/articles/business'
import sportpitanie from '@/articles/sportpitanie'
import sale from '@/articles/sale'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      alias: ['/success', '/fail', '/index.html', '/index.shtml', '/indexs.html'],
      name: 'index',
      component: index,
      meta: {
        header: 1,
        map: 1
      }
    },
    {
      path: '/promocode/:code',
      name: 'index',
      component: index,
      meta: {
        header: 1,
        map: 1
      }
    },
    {
      path: '/oferta',
      name: 'oferta',
      component: oferta
    },
    {
      path: '/stocks',
      name: 'stocks',
      component: stocks,
      meta: {
        map: 1
      }
    },
    {
      path: '/restaurants',
      name: 'restaurants',
      component: restaurants,
      meta: {
        map: 1
      }
    },
    {
      path: '/restaurant/:id',
      name: 'restaurant',
      component: restaurant,
      meta: {
        map: 1
      }
    },
    {
      path: '/restaurant/:id/reviews',
      name: 'restaurantReview',
      component: restaurantReview
    },
    {
      path: '/product/:id',
      name: 'product',
      component: product,
      meta: {
        map: 1
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: cart,
      meta: {
        map: 1
      }
    },
    {
      path: '/cabinet',
      name: 'cabinet',
      component: cabinet
    },
    {
      path: '/profile',
      name: 'clientIndex',
      component: clientIndex
    },
    {
      path: '/lk',
      name: 'userMonitor',
      component: userMonitor
    },
    {
      path: '/lk/personal',
      name: 'userPersonal',
      component: userPersonal
    },
    {
      path: '/lk/presents',
      name: 'userPresents',
      component: userPresents
    },
    {
      path: '/lk/present/:id',
      name: 'userPresent',
      component: userPresent
    },
    {
      path: '/lk/restaurants',
      name: 'userRestaurants',
      component: userRestaurants
    },
    {
      path: '/lk/restaurant/:id',
      name: 'userRestaurant',
      component: userRestaurant
    },
    {
      path: '/lk/stats',
      name: 'userStats',
      component: userStats
    },
    {
      path: '/lk/referral',
      name: 'userReferral',
      component: userReferral
    },
    {
      path: '/profile/edit',
      name: 'clientProfile',
      component: clientProfile
    },
    {
      path: '/profile/bonus',
      name: 'clientBonus',
      component: clientBonus
    },
    {
      path: '/profile/referral',
      name: 'clientReferral',
      component: clientReferral
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/blog',
      name: 'blog',
      component: blog
    },
    {
      path: '/blog/:id',
      name: 'singleBlog',
      component: singleBlog
    },
    {
      path: '/restaurants_services',
      name: 'forRestaurants',
      component: forRestaurants
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: contacts
    },
    {
      path: '/present',
      name: 'presents',
      component: presents
    },
    {
      path: '/affiliate',
      name: 'partners',
      component: partners
    },
    {
      path: '/work',
      name: 'work',
      component: work
    },
    {
      path: '/white_label',
      name: 'wl',
      component: wl
    },
    {
      path: '/franchise',
      name: 'franchise',
      component: franchise
    },
    {
      path: '/sushi',
      name: 'sushi',
      component: sushi
    },
    {
      path: '/pizza',
      name: 'pizza',
      component: pizza
    },
    {
      path: '/snacks',
      name: 'snacks',
      component: snacks
    },
    {
      path: '/healthy',
      name: 'healthy',
      component: healthy
    },
    {
      path: '/burger',
      name: 'burger',
      component: burger
    },
    {
      path: '/dessert',
      name: 'dessert',
      component: dessert
    },
    {
      path: '/cancer',
      name: 'cancer',
      component: cancer
    },
    {
      path: '/lunch',
      name: 'lunch',
      component: lunch
    },
    {
      path: '/pie',
      name: 'pie',
      component: pie
    },
    {
      path: '/barbecue',
      name: 'barbecue',
      component: barbecue
    },
    {
      path: '/salad',
      name: 'salad',
      component: salad
    },
    {
      path: '/cake',
      name: 'cake',
      component: cake
    },
    {
      path: '/coffee',
      name: 'coffee',
      component: coffee
    },
    {
      path: '/beer',
      name: 'beer',
      component: beer
    },
    {
      path: '/development',
      name: 'development',
      component: development
    },
    {
      path: '/profit',
      name: 'profit',
      component: profit
    },
    {
      path: '/seasonality',
      name: 'seasonality',
      component: seasonality
    },
    {
      path: '/secrets',
      name: 'secrets',
      component: secrets
    },
    {
      path: '/soups',
      name: 'soups',
      component: soups
    },
    {
      path: '/targetolog',
      name: 'targetolog',
      component: targetolog
    },
    {
      path: '/investment',
      name: 'investment',
      component: investment
    },
    {
      path: '/saas',
      name: 'saas',
      component: saas
    },
    {
      path: '/authors_cuisine',
      name: 'authorsCuisine',
      component: authorsCuisine
    },
    {
      path: '/asian',
      name: 'asian',
      component: asian
    },
    {
      path: '/united-states',
      name: 'unitedStates',
      component: unitedStates
    },
    {
      path: '/armenian',
      name: 'armenian',
      component: armenian
    },
    {
      path: '/balkan',
      name: 'balkan',
      component: balkan
    },
    {
      path: '/eastern',
      name: 'eastern',
      component: eastern
    },
    {
      path: '/georgian',
      name: 'georgian',
      component: georgian
    },
    {
      path: '/european',
      name: 'european',
      component: european
    },
    {
      path: '/indian',
      name: 'indian',
      component: indian
    },
    {
      path: '/italian',
      name: 'italian',
      component: italian
    },
    {
      path: '/caucasian',
      name: 'caucasian',
      component: caucasian
    },
    {
      path: '/chinese',
      name: 'chinese',
      component: chinese
    },
    {
      path: '/korean',
      name: 'korean',
      component: korean
    },
    {
      path: '/mexican',
      name: 'mexican',
      component: mexican
    },
    {
      path: '/russian',
      name: 'russian',
      component: russian
    },
    {
      path: '/slavic',
      name: 'slavic',
      component: slavic
    },
    {
      path: '/japan',
      name: 'japan',
      component: japan
    },
    {
      path: '/exotic',
      name: 'exotic',
      component: exotic
    },
    {
      path: '/kids',
      name: 'kids',
      component: kids
    },
    {
      path: '/diet',
      name: 'diet',
      component: diet
    },
    {
      path: '/cancers',
      name: 'cancers',
      component: cancers
    },
    {
      path: '/cakes',
      name: 'cakes',
      component: cakes
    },
    {
      path: '/osetinian',
      name: 'osetinian',
      component: osetinian
    },
    {
      path: '/inoffice',
      name: 'inoffice',
      component: inoffice
    },
    {
      path: '/gotovaya_eda',
      name: 'gotovayaEda',
      component: gotovayaEda
    },
    {
      path: '/voda',
      name: 'voda',
      component: voda
    },
    {
      path: '/faq',
      name: 'faq',
      component: faq
    },
    {
      path: '/business',
      name: 'business',
      component: business
    },
    {
      path: '/sportpitanie',
      name: 'sportpitanie',
      component: sportpitanie
    },
    {
      path: '/sale',
      name: 'sale',
      component: sale
    },
    {
      path: '*',
      name: 'article',
      component: article
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js